import { useFetch } from './useFetch'
import type { ConfigDTO } from '../types'

const extractConfigs = (json: unknown): ConfigDTO[] =>
  (json as { configs: ConfigDTO[] }).configs ?? []

export function useConfig(query: string) {
  const { data: configs, isLoading, error } =
    useFetch<ConfigDTO[]>(query, [], extractConfigs)
  return { configs, isLoading, error }
}
